import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Arbetstagare } from '../interfaces/arbetstagare.interface';

@Component({
    selector: 'arbetstagare-icon',
    template: `<span [title]="gender==='female' ? 'Kvinna' : 'Man'"><fa-icon [icon]="['fas', gender]" [mask]="['fas', 'circle']" [size]="size || ''" [style.color]="color || (gender==='female' ? '#614' : '#047')" [fixedWidth]="true" transform="shrink-4"></fa-icon></span>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ArbetstagareIconComponent {
  @Input() public arbetstagare: Arbetstagare;
  @Input() public size: string;
  @Input() public color: string;

  public get gender(): string {
    try {
      return +this.arbetstagare.personNr12Siffror.charAt(11) % 2 ? 'male' : 'female';
    } catch(e) {
      return 'question';
    }
  };
}
